import { render, staticRenderFns } from "./vFormGlobalSettings.vue?vue&type=template&id=6059412e&scoped=true&"
import script from "./vFormGlobalSettings.vue?vue&type=script&lang=js&"
export * from "./vFormGlobalSettings.vue?vue&type=script&lang=js&"
import style0 from "./vFormGlobalSettings.vue?vue&type=style&index=0&id=6059412e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6059412e",
  null
  
)

export default component.exports